/* eslint-disable @typescript-eslint/no-explicit-any */
import Cookies from 'js-cookie';
import queryString from 'query-string';

export function nucampTracking(event: {medium?: string, campaign?: string, content?: string, term?: string, keyword?: string}) {
  const UTNTrack = {
    source: "nucamp",
    medium: event.medium || "",
    campaign: event.campaign || "",
    content: event.content || "",
    term: event.term || "",
    keyword: event.keyword || "",
    timestamp: new Date(),
  }
  pushUTN(UTNTrack);
}

function pushUTN(tag:any) {
  try {
      if (window.localStorage) {
      // localStorage supported
      let UTN;
      UTN = getUTN();
      if (!UTN) {
        UTN = [];
      }
      UTN.push(tag)
      window.localStorage.setItem('utn', JSON.stringify(UTN));
    }
  } catch (err) {
    console.log(err);
  }
}

export function getUTN(){
  try {
    if (window.localStorage) {
      const UTN = localStorage.getItem('utn');
      if (UTN) {
        const arrUTN = JSON.parse(UTN);
        if (arrUTN.length && arrUTN.length > 0)
          return arrUTN;
        else return null;
      }
        else return null;
    } else return null;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    return null;
  }
}

export function getCookie(key: string){
  return Cookies.get(key);
}

export function queryParamMap(queryParam?: string) {
  if (queryParam) {
    const query = queryString.parse(window.location.search);
    const qParam = query[queryParam];
    if (qParam && typeof qParam === 'string') return qParam;
    else return "";
  } else {
    return "";
  }
}

export function mergeUTNCodes(tracking: any[]) {
  const localUTN = getUTN();

  if (!tracking) tracking = [];
  let dirty = false;
  if (localUTN) {
    localUTN.forEach((utn: any) => {
      if (tracking.findIndex(u => u.timestamp === utn.timestamp) === -1) {
        tracking.push(utn);
        dirty = true;
      }
    })
  }
  return {merged: tracking, dirty: dirty};
}

export function utnTracking() {
  const UTNTrack ={
    source: "",
    medium: "",
    campaign: "",
    content: "",
    term: "",
    keyword: "",
    gclid: "",
    msclkid: "",
    timestamp: new Date(),
  }
  const source = queryParamMap("utm_source");

  // if the user comes from Google, Facebook or Microsoft Paid
  if (source && source !== '') {
    UTNTrack.source = queryParamMap(`utm_source`).toLowerCase();
    UTNTrack.medium = queryParamMap(`utm_medium`).toLowerCase();
    UTNTrack.campaign = queryParamMap(`utm_campaign`).toLowerCase();
    UTNTrack.content = queryParamMap(`utm_content`).toLowerCase();
    UTNTrack.term = queryParamMap(`utm_term`).toLowerCase();
    UTNTrack.keyword = queryParamMap(`utm_keyword`).toLowerCase();
    UTNTrack.gclid = queryParamMap(`gclid`);
    UTNTrack.msclkid = queryParamMap(`msclkid`);
    pushUTN(UTNTrack);
  }
}

export function is(device: "mobile" | "desktop" | "sm" | "md" | "lg" | "xl" | "2xl") {
  const breakpoints = {
    mobile: 640,
    desktop: 1024,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    "2xl": 1400,
  };
  if (window && window.innerWidth) {
    return window.innerWidth < breakpoints[device];
  } else {
    return true;
  }
}

export function isDarkMode() {
  if (window && window?.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  } else {
    return false;
  }
}